import * as React from 'react';

import { usePrintRedirect } from 'lib/hooks/use-print-redirect';
import { useDetectPrint } from 'lib/use-detect-print';

import { FooterContainer } from 'containers/common/app/footer-container';
import { HeaderContainer } from 'containers/common/app/header-container';
import { PageContainer } from 'containers/page/page-container';

import { GoToTopButton } from 'components/go-to-top-button';
import { TabIdList } from 'components/tab-list';

import { LandingBlockOneContainer } from './landing-block-one-container';
import { LandingBlockThreeContainer } from './landing-block-three-container';
import { LandingBlockThreeContainerPrintable } from './landing-block-three-container-printable';
import { LandingBlockTwoContainer } from './landing-block-two-container';
import { LandingBlockTwoContainerPrintable } from './landing-block-two-container-printable';
import { LandingHeroBlockContainer } from './landing-hero-block-container';

export const LandingContainer: React.FC<{ printendVersion?: boolean }> = ({
  printendVersion = false,
}) => {
  let isPrinting = useDetectPrint();

  usePrintRedirect();

  if (isPrinting === false) {
    isPrinting = printendVersion;
  }

  if (isPrinting) {
    const printSectionIdList: string[] = Object.values(TabIdList).filter(
      (id) => id !== TabIdList.ContactUs,
    );

    printSectionIdList.push(TabIdList.ContactUs);
    return (
      <PageContainer>
        <main id="main" tabIndex={-1}>
          <LandingHeroBlockContainer />
          <LandingBlockOneContainer />
          <>
            {printSectionIdList.map((id: string) => {
              return (
                <React.Fragment key={`tab-key-${id}`}>
                  <LandingBlockTwoContainerPrintable id={id} />
                  <LandingBlockThreeContainerPrintable id={id} />
                </React.Fragment>
              );
            })}
          </>
        </main>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <LandingHeroBlockContainer />
        <LandingBlockOneContainer />
        <LandingBlockTwoContainer />
        <LandingBlockThreeContainer />
      </main>
      <GoToTopButton />
      <FooterContainer />
    </PageContainer>
  );
};
